export default __webpack_public_path__ + "static/char-s-42-zh-Hant-31ed299729be0b53cfa1a461c854a82e.png";